export default __webpack_public_path__ + "static/media/object-4.f0af160d.webp";